import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import CheckBox from '../../../../../../../common/components/Checkbox';
import { InputWithEmoji } from '../../../../../../../common/components/InputWithEmoji/InputWithEmoji';
import { useValidationMessageCRUDActions } from '@mm/state/actions/ValidationMessageCRUDActions';
import ChatbotModel, { MessagesSettings } from '@mm/state/model/ChatbotModel';

const INPUT_LABEL =
  'Message sent when a contact enters an invalid phone number';
const INPUT_PLACEHOLDER = 'Please enter a phone number';

type Props = {
  bot: ChatbotModel;
  onBotChange: (bot: ChatbotModel) => void;
};

export const InvalidPhoneNumber = ({ bot, onBotChange }: Props) => {
  const validation = get(bot, 'validationMessages.phone');
  const { create, update } = useValidationMessageCRUDActions();

  const [validationBody, setValidationBody] = useState('');
  useEffect(() => setValidationBody(validation.body), [validation]);

  const updateBody = () => {
    if (validation.body === validationBody) {
      return;
    }
    const updatedValidation = {
      ...validation,
      body: validationBody,
    };

    const action = updatedValidation.id ? update : create;
    action(updatedValidation);
  };

  const onChangeCheckbox = () => {
    const messagesSettings = bot.messagesSettings || {
      disablePhoneValidation: false,
    };
    messagesSettings.disablePhoneValidation =
      !messagesSettings.disablePhoneValidation;

    onBotChange({
      ...bot,
      messagesSettings: messagesSettings as MessagesSettings,
    });
  };

  return (
    <div>
      <div className="bot-publishing-pane__logo-item-subtext">
        <CheckBox
          isChecked={!get(bot, 'messagesSettings.disablePhoneValidation')}
          label={INPUT_LABEL}
          className="bot-system-messages__checkbox"
          onToggle={onChangeCheckbox}
        />
      </div>
      <InputWithEmoji
        placeholder={INPUT_PLACEHOLDER}
        maxLength={100}
        value={validationBody}
        onChange={setValidationBody}
        onBlur={updateBody}
        disabled={!!get(bot, 'messagesSettings.disablePhoneValidation')}
      />
    </div>
  );
};
